import React from 'react';
import {
  ArrowRight,
  ArrowLeftRight,
  User,
  MessageCircle,
  Shield,
  Star,
  BarChart3,
  Search,
  Upload,
  Handshake,
  Phone,
  Laptop,
  Shirt,
  Dumbbell,
  Sofa,
  Car,
  Gamepad2,
  Baby,
  PawPrint,
  Wrench,
  BookOpen,
  Watch,
  Gem,
  Music,
  Camera,
  Smartphone,
  CheckCircle2,
  Globe,
  Menu,
  X,
  ChevronDown,
  Clock,
  Mail,
  MapPin,
} from 'lucide-react';

/**
 * Icon registry — maps string keys to Lucide components.
 * Add new icons here as the app grows.
 * Keeps all icon imports in one place.
 */
const ICON_MAP = {
  ArrowRight,
  ArrowLeftRight,
  User,
  MessageCircle,
  Shield,
  Star,
  BarChart3,
  Search,
  Upload,
  Handshake,
  Phone,
  Laptop,
  Shirt,
  Dumbbell,
  Sofa,
  Car,
  Gamepad2,
  Baby,
  PawPrint,
  Wrench,
  BookOpen,
  Watch,
  Gem,
  Music,
  Camera,
  Smartphone,
  CheckCircle2,
  Globe,
  Menu,
  X,
  ChevronDown,
  Clock,
  Mail,
  MapPin,
};

/**
 * <Icon name="Laptop" size={22} color="#1718BF" />
 */
function Icon({ name, size = 22, color, strokeWidth = 1.8, style, className }) {
  const Component = ICON_MAP[name];
  if (!Component) {
    console.warn(`Icon "${name}" not found in registry.`);
    return null;
  }
  return (
    <Component
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      style={style}
      className={className}
    />
  );
}

export default Icon;

// Named exports for direct use
export {
  ArrowRight, ArrowLeftRight, User, MessageCircle, Shield, Star, BarChart3,
  Search, Upload, Handshake, Phone, Laptop, Shirt, Dumbbell, Sofa, Car,
  Gamepad2, Baby, PawPrint, Wrench, BookOpen, Watch, Gem, Music, Camera,
  Smartphone, CheckCircle2, Globe, Menu, X, ChevronDown, Clock, Mail, MapPin,
};
